import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { FormGroupAtpHtml, FormGroupBaseHtml, ParametersArrayHtml } from '../models/HtmlModels';
import { FormArrayContextParameters, FormGroupContextBase } from '../models/FormModels';

@Injectable({
  providedIn: 'root'
})
export class VoucherAtpHandlerHtmlService {
  constructor() {}

  createFormGroupAtpHtml(formGroup: FormArray<FormGroup<FormGroupContextBase>>): FormGroupAtpHtml[] {
    const formGroupAtpHtml: FormGroupAtpHtml[] = [];

    formGroup.controls.forEach((group) => {
      formGroupAtpHtml.push(this.createFormGroupFromHtml(group.controls.name.value, group));
    });

    return formGroupAtpHtml;
  }

  createFormGroupFromHtml(title: string, formGroup: FormGroup<FormGroupContextBase>): FormGroupAtpHtml {
    return {
      title,
      configType: formGroup.controls.configType.value,
      formGroup: formGroup,
      propList: this.createFormGroupBaseHtml(formGroup),
      isPanelOpen: false
    };
  }

  createFormGroupBaseHtml(formGroup: FormGroup<FormGroupContextBase>): FormGroupBaseHtml {
    switch (formGroup.controls.configType.value) {
      case 'DOMAIN':
        return {
          enabledModules: 'enabledModules',
          parameters: this.createFormArrayParametersHtml('parameters', formGroup.controls.parameters),
          secureParameters: this.createFormArrayParametersHtml('secureParameters', formGroup.controls.secureParameters)
        };
      default:
        return {
          enabledModules: 'enabledModules',
          parameters: this.createFormArrayParametersHtml('parameters', formGroup.controls.parameters),
          secureParameters: this.createFormArrayParametersHtml('secureParameters', formGroup.controls.secureParameters),
          subConfig: formGroup.controls.subConfig
        };
    }
  }

  private createFormArrayParametersHtml(title: string, formArray: FormArray<FormGroup<FormArrayContextParameters>>): ParametersArrayHtml {
    return {
      title,
      formArray
    };
  }
}

